// extracted by mini-css-extract-plugin
module.exports = {"footer":"edit-modal_footer__1CP2v"};